import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-dialog-wrapper',
	templateUrl:'./WaPageDialogWrapperProPage.html',
	styles: [],
	styleUrls:['./WaPageDialogWrapperProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageDialogWrapperProPage
{
	mdContent_398 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageDialogWrapper;
\`\`\``;
	mdContent_399 = `\`\`\`java
new WaPageDialogWrapper<>()
\`\`\``;
}
